import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=b105baa4&scoped=true"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=b105baa4&prod&lang=scss"
import style1 from "./TermsOfService.vue?vue&type=style&index=1&id=b105baa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b105baa4",
  null
  
)

export default component.exports